import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import AcademiasListar from '../section-pages/academias-listar';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiAcademias from '../services/academiaService';

export default function Home() {
  const image1 = '../../img/background/bg-header.png';
  const [academias, setAcademias] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const fetchAcademias = async () => {
    try {
      const response = await ApiAcademias.listar();
      setAcademias(response.data.academias);
    } catch (error) {
      console.error('Erro ao buscar academias:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
        const loader = document.getElementById('mainpreloader');
        if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = 'none';
        }, 600)
    }
    fetchAcademias();
  }, []);
  return (
    <>
    {/* HEAD */}
    <Helmet>
      <link rel="icon" href="./img/icon.png" />
      <title>Fetron - Federação de Taekwondô de Rondônia</title>
    </Helmet>

    {/* LOADER */}
    <div id='mainpreloader'>
      <Preloader/>
    </div>

    {/* MENU */}
    <div className="home dark-scheme">
      <header id="header-wrap">
         <Navbar />
      </header>

        <section className="no-bg">
          <div>
            <img src="../../img/background/bg-header.png" width="100%"/>
          </div>
          <div className="container z-9">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <center>
                  <h3 className="titulo">LOCALIZAÇÃO DAS ACADEMIAS</h3>
                </center>
                <p>
                  <center>
                    Encontre uma escola de Taekwondo perto de você!
                  </center>
                </p>
                <p>
                  <center>
                    A FETRON é uma organização regional filiada ao sistema olimpico oficial: Confederação Brasileira de Taekwondo - CBTKD; 
                    <br/>Comitê Olímpico Brasileiro - COB e Federação Mundial de Taekwondo - WT. As academias abaixo 
                    <br/>relacionadas são reconhecidas e submetidas aos regulamentos oficias.
                  </center>
                </p>
              </div>        
            </div>
          </div>
        </section>

      {/* section */}
      <section className="no-top">
        <br/>
        <AcademiasListar academias={academias} />
      </section>

      <section className="no-top">
        <img src="../../img/background/foot.png" width="100%"/>
      </section>

      {/* footer */}
      <Footer/> 


    </div>
    <ScrollToTopBtn />
    </>
  )
}
